module.exports = __webpack_public_path__ + "img/civil_engineering_splash.afe7deb9.jpg";